<template>
<div style="width: 100%; height: 100%; overflow-y: auto; overflow-x: hidden;">
    <div style="display: flex; flex-direction: column; padding: 30px; gap: 10px; width: 100%; padding-top: 20px;">
        <!-- <div style="margin-bottom: 10px;"><el-tag color="rgb(215,222,231)" effect="dark" class="left-tag" size="large" style="width: fit-content; color: black; font-weight: bold;">
            Introduction to the design space
        </el-tag></div> -->
        <!-- WHY -->
        <div><el-tag color="rgb(11,175,169)" effect="dark" class="left-tag" size="large" style="width: fit-content;">
            <strong>WHY</strong> apply visual metaphor?
        </el-tag></div>
        <div style="margin-bottom: 30px;">
            <FlipCard v-for="name in whyList" :key="name" :info="spaceInfo[name]"></FlipCard>
        </div>
        <!-- WHAT -->
        <div><el-tag color="rgb(118,118,251)" effect="dark" class="left-tag" size="large" style="width: fit-content;">
            <strong>WHAT</strong> data to show?
        </el-tag></div>
        <div style="margin-bottom: 30px;">
            <FlipCard v-for="name in whatList" :key="name" :info="spaceInfo[name]"></FlipCard>
        </div>
        <!-- HOW -->
        <div style="display: flex; gap: 20px; align-items: center;">
            <el-tag color="rgb(96,140,244)" effect="dark" class="left-tag" size="large">
            <strong>HOW</strong> to establish conceptually?
            </el-tag>
            <!-- <span style="font-size: 17px">
            Establish visual metaphors with mappings by:
            </span> -->
        </div>
        <div style="margin-top: 30px;"><el-tag effect="dark" class="how-tag" size="large" style="width: fit-content;">
            Denotation Mappings
        </el-tag></div>
        <div>
            <FlipCard v-for="name in howList1" :key="name" :info="spaceInfo[name]"></FlipCard>
        </div>
        <div style="margin-top: 30px;"><el-tag effect="dark" class="how-tag" size="large" style="width: fit-content;">
            Connotation Mappings
        </el-tag></div>
        <div style="margin-bottom: 10px;">
            <FlipCard v-for="name in howList2" :key="name" :info="spaceInfo[name]"></FlipCard>
        </div>
    </div>
</div>
</template>

<script>
import { chn2eng, eng2chn, translate2chn, introduction } from '../utils/defs.js';
import FlipCard from './FlipCard.vue';
export default {
    name: 'Space',
    components: {
        FlipCard,
    },
    props: {
    },
    watch: {
    },
    data() {
      return {
        chn2eng: chn2eng,
        eng2chn: eng2chn,
        intro: introduction,
        whatList: ['Data Items', 'Data Attributes', 'Data Facts', 'Data Relationships'],
        whyList: ['Illustrate Topics', 'Explain Data', 'Evoke Emotion'],
        howList1: ['Appearance', 'Silhouette', 'Structure'],
        howList2: ['Status', 'Function', 'Process', 'Orientation', 'Color'],
      }
    },
    computed: {
        spaceInfo() {
            const tmp = this.intro;
            for (const k of this.whatList) {
                tmp[k].name = k;
                tmp[k].category = 'what';
                tmp[k].icon = require(`../assets/SVG/${eng2chn[k]}.svg`);
                tmp[k].color = 'rgb(118,118,251)'
            }
            for (const k of this.whyList) {
                tmp[k].name = k;
                tmp[k].category = 'why';
                tmp[k].icon = require(`../assets/SVG/${eng2chn[k]}.svg`);
                tmp[k].color = 'rgb(11,175,169)'
            }
            for (const k of this.howList1) {
                tmp[k].name = k;
                tmp[k].category = 'how';
                tmp[k].icon = require(`../assets/SVG/${eng2chn[k]}.svg`);
                tmp[k].color = 'rgb(96,140,244)'
            }
            for (const k of this.howList2) {
                tmp[k].name = k;
                tmp[k].category = 'how';
                tmp[k].icon = require(`../assets/SVG/${eng2chn[k]}.svg`);
                tmp[k].color = 'rgb(96,140,244)'
            }
            return tmp;
        },
    },
    methods: {
      translate(name, eng=1) {
        if (eng) return translate2chn(name);
        return translate2chn(this.chn2eng[name]);
      },
      imageUrl(name, thumb=0) {
        return '/api/image?name=' + name + (thumb ? '&thumb=1' : '');
      },
    }
}
</script>
